import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { urlWithQuery } from '~/utils/url';
import type { MagicDoorBillCreditDto, MagicDoorBillCreditPaginationDto } from '~/swagger/portal/Api';

export type GetInvoiceCreditsParams = {
  page?: number;
  pageSize?: number;
  'creditDate.start'?: string;
  'creditDate.end'?: string;
  'amount.from'?: number;
  'amount.to'?: number;
  'amount.includeFrom'?: boolean;
  'amount.includeTo'?: boolean;
};

export class InvoiceCreditsRepository extends BaseRestRepository {
  private readonly BASE_URL = '/api/invoices/credits';

  async getInvoiceCredits(params?: GetInvoiceCreditsParams): Promise<MagicDoorBillCreditPaginationDto> {
    const url = this.BASE_URL;
    const response = await this.fetchWithAuth(urlWithQuery(url, params));
    return this.getJsonResponse(response);
  }

  async getInvoiceCredit(magicDoorBillCreditId: string): Promise<MagicDoorBillCreditDto> {
    const url = `${this.BASE_URL}/${magicDoorBillCreditId}`;
    const response = await this.fetchWithAuth(url, { method: 'GET' });
    return this.getJsonResponse(response);
  }
}

export const invoiceCreditsRepository = new InvoiceCreditsRepository();
